import moment from "moment";
import useTranslator from "../../hooks/useTranslator";
import {
  formatPropertyAddress,
  haveValue,
  isInsuranceUnderReview,
} from "../../helper/common";

const InsuranceActivatedPopup = ({
  show,
  onClose,
  onComplete,
  propertyData,
}) => {
  const { _t } = useTranslator();

  if (!show) return null;

  const insuranceData = propertyData?.insurance_data;
  const paymentAmount = insuranceData?.payment_amount;
  const paymentDate = propertyData?.insurance_payment_date;
  const currentLang = localStorage.getItem("i18nextLng") || "en-us";
  const propertyAddress = formatPropertyAddress(propertyData, currentLang);
  const isUnderReview = isInsuranceUnderReview(insuranceData);

  return (
    <div
      className="popup-overlay insurance-payment-success-overlay fixed inset-0 d-flex align-items-center justify-content-center z-50 wrapper-modal"
      style={{ zIndex: 9999 }}
    >
      <div className="ins-activated-card ins-payment-success-card">
        <button
          type="button"
          className="ins-activated-close"
          onClick={onClose}
          aria-label={_t("close")}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 6 6 18" />
            <path d="m6 6 12 12" />
          </svg>
        </button>

        <div className="ins-activated-icon-wrap ins-payment-success-icon">
          <svg
            width="28"
            height="28"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="m5 12 4 4L19 6" />
          </svg>
        </div>

        <h2 className="ins-activated-heading">
          {_t("insurancePaymentReceivedPropertyAwarded")}
        </h2>
        {haveValue(propertyAddress) && (
          <p className="ins-activated-subheading ins-payment-success-subheading">
            <strong>{propertyAddress}</strong>{" "}
            {_t("insurancePropertyIsNowAwarded")}
          </p>
        )}

        <div className="ins-activated-details-card ins-payment-success-details">
          <div className="ins-activated-row">
            <span className="ins-activated-label">
              {_t("insurancePremium")}
            </span>
            <span className="ins-activated-value-bold">
              {haveValue(paymentAmount) ? `${paymentAmount} €` : "-"}
              {haveValue(paymentDate) &&
                ` · ${_t("paid")} ${moment(paymentDate).format("DD MMM YYYY")}`}
            </span>
          </div>
          <div className="ins-activated-row">
            <span className="ins-activated-label">{_t("policyStart")}</span>
            <span className="ins-activated-value-bold">
              {isUnderReview
                ? _t("insuranceChoosePolicyStartOnceConfirmed")
                : _t("insuranceChoosePolicyStartNextStep")}
            </span>
          </div>
          <div className="ins-activated-row">
            <span className="ins-activated-label">{_t("policy")}</span>
            {isUnderReview ? (
              <span className="insurance-under-review-chip">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="11" cy="11" r="7" />
                  <path d="m20 20-4-4" />
                </svg>
                {_t("underReview")}
              </span>
            ) : (
              <span className="insurance-pending-contract-chip">
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="9" />
                  <path d="M12 7v5l3 2" />
                </svg>
                {_t("pendingContract")}
              </span>
            )}
          </div>
          {haveValue(insuranceData?.invoice_document) && (
            <div className="ins-activated-row">
              <span className="ins-activated-label">{_t("receipt")}</span>
              <a
                className="ins-payment-success-invoice-link"
                href={insuranceData.invoice_document}
                target="_blank"
                rel="noreferrer"
              >
                {_t("downloadInvoice")}
              </a>
            </div>
          )}
        </div>

        {isUnderReview ? (
          <div className="ins-payment-success-note ins-payment-success-note--review">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="9" />
              <path d="M12 16v-4" />
              <path d="M12 8h.01" />
            </svg>
            <div>
              <strong>{_t("insuranceCheckingCaseBeforeIssuingPolicy")}</strong>
              <p>{_t("insuranceManualReviewExplanation")}</p>
            </div>
          </div>
        ) : (
          <div className="ins-payment-success-note">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M10.3 3.4 2.6 17a2 2 0 0 0 1.7 3h15.4a2 2 0 0 0 1.7-3L13.7 3.4a2 2 0 0 0-3.4 0Z" />
              <path d="M12 9v4" />
              <path d="M12 17h.01" />
            </svg>
            <div>
              <strong>{_t("oneStepLeftToActivatePolicy")}</strong>
              <p>{_t("insurancePendingContractExplanation")}</p>
            </div>
          </div>
        )}

        <div className="ins-payment-success-actions">
          {isUnderReview ? (
            <button
              type="button"
              className="btnNext addGuarantorButton ins-payment-success-done"
              onClick={onClose}
            >
              {_t("done")}
            </button>
          ) : (
            <>
              <button
                type="button"
                className="btnNext ins-payment-success-later"
                onClick={onClose}
              >
                {_t("doItLater")}
              </button>
              <button
                type="button"
                className="btnNext addGuarantorButton ins-payment-success-complete"
                onClick={onComplete}
              >
                {_t("addBeneficiaryAndContract")}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default InsuranceActivatedPopup;
